import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportUtils from "../common/support_utils.js";

export class NenOsSupportModel extends IllumioEventEmitter {
    constructor() {
        super();
        // this.dataLoadEvent = new Event(this);
        let url = '/api/v1/pce_software/os_support/nen.json';
        if (IllumioSupportUtils.isPublicResource()) {
            url = '/api/v1/shared/pce_software/os_support/nen.json';
        }
        $.ajax({
            dataType: 'json',
            method: 'get',
            contentType: 'application/json; charset=utf-8',
            url: url,
            error: this.ajaxErrorHandler.bind(this),
            success: this.ajaxSuccessHandler.bind(this),
        });
    }

    ajaxSuccessHandler(response, textStatus, jqXHR) {
        console.debug('ajaxSuccessHandler() invoked.');
        if (response && response.data) {
            this.success = true;
            this.data = response.data;
            // this.dataLoadEvent.notify();
            this.emit('dataLoad', {});
        } else {
            this.success = false;
            this.error = response.error;
        }
    }

    ajaxErrorHandler() {
        console.warn('ajaxErrorHandler() invoked.');
        const result = new NenOsSupportResult();
        result.renderError(null);
    }

        /**
         * Public method
         */
        getRecordByVersion(nenVersion) {
            if (this.data) {
                for (let id in this.data['os_content']) {
                    if (this.data['os_content'][id].software_version===nenVersion) {
                        return this.data['os_content'][id];
                    }
                }
            }

            return null;
        }
}

export class NenOsSupportView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;
        this.formDiv = document.getElementById('formDiv');
        this.nenVersionSelect = document.getElementById('nenVersionSelect');

        this.nenVersionSelect.onchange = this.nenVersionSelectOnChangeHandler.bind(this);

        // this.model.dataLoadEvent.attach(dataLoadEventHandler.bind(this));
        this.model.on('dataLoad', this.dataLoadEventHandler.bind(this));

        this.result = new NenOsSupportResult();
    }

        /**
         * Public method
         */
        showResult(id) {
            if (!id && this.nenVersionSelect && this.nenVersionSelect.options.selectedIndex>=0) {
                id = this.nenVersionSelect.options[this.nenVersionSelect.options.selectedIndex].value
            }
            console.debug(`selected id: ${id}`);
            this.result.render(this.model.data['os_content'][id], this.model.data['compatibility'][this.model.data['os_content'][id]['software_version']]);

            location.hash = this.model.data['os_content'][id].software_version;

            this.trackAnalytic(this);
        }

    nenVersionSelectOnChangeHandler(event) {
        console.debug('nenVersionSelectOnChangeHandler() invoked');
        this.showResult(event.target.value);
    }

    dataLoadEventHandler(event) {
        console.debug('dataLoadEventHandler() invoked!');
        if (this.model.success && this.model.data['os_content']) {
            let itemCounter = 0;
            const optionsArray = new Array();
            for (let id in this.model.data['os_content']) {
                const item = this.model.data['os_content'][id];

                let text = item.software_version;
                if (item.lts) {
                    text += ' (LTS)';
                }

                optionsArray.push(new Option(text, item.id));
            }
            if (optionsArray.length>0) {
                const optionsArraySortHandler = function(a, b) {
                    if (a.text>b.text) {
                        return -1;
                    } else if (a.text<b.text) {
                        return 1;
                    } 
                    return 0;
                }
                optionsArray.sort(optionsArraySortHandler);

                const optionsArrayForEachHandler = function(optionItem) {
                    console.debug(optionItem);
                    console.debug(this);
                    this.nenVersionSelect.options.add(optionItem);
                }
                optionsArray.forEach(optionsArrayForEachHandler, this);
            }
            if (this.nenVersionSelect.options.length>0) {
                this.defaultNenVersionSelect.call(this);
                this.formDiv.classList.remove('hide');
                $(this.nenVersionSelect).change();
            } else {
                this.result.renderError(null);
            }
        }
    }

    defaultNenVersionSelect() {
        let found = false;
        if (location.hash && location.hash.length>1) {
            const record = this.model.getRecordByVersion(location.hash.substring(1));
            if (record) {
                for (let i=0;i<this.nenVersionSelect.options.length;i++) {
                    if (this.nenVersionSelect.options[i].text===record.software_version) {
                        found = true;
                        this.nenVersionSelect.options[i].selected = true;
                        break;
                    }
                }
            }
        }

        if (!found) {
            this.nenVersionSelect.options.selectedIndex = 0;
        }
    }

    trackAnalytic() {
        if (IllumioSupportUtils && this.nenVersionSelect.selectedIndex>=0) {
            const eventLabel = this.nenVersionSelect.options[this.nenVersionSelect.selectedIndex].text;
            console.debug('eventLabel: ', eventLabel);
            IllumioSupportUtils.trackGaEvent('OS Support', 'NEN', eventLabel);
        }

        const qs = IllumioSupportUtils.getJsonFromUrl(location.href);
        if (qs && qs['source']) {
            IllumioSupportUtils.trackGaEvent('OS Support', 'NEN Redirect', qs['source'])
            console.debug('Tracked NEN redirect');
        }
    }
}

export class NenOsSupportController {
    constructor(model, view) {
        this.model = model;
        this.view = view;
    }
}

export class NenOsSupportResult {
    constructor() {
        this.nenContent = document.getElementById('nenContent');
    }

        /**
         * Public method
         */
        render(record, compatibility) {
            this.nenContent.innerHTML = this.createCompatibilityTable(record, compatibility)
            this.nenContent.innerHTML += record.view;
            this.updateSupportedOperatingSystemsFormat()
            this.updateHeading(record);
        }
        /**
         * Public method
         */
        renderError(message) {
            if (!message) {
                message = `We're sorry that we have experienced technical difficulties in retrieving the content. Please try again later.`;
            }
            this.nenContent.innerHTML = message;
        }

    createCompatibilityTable(record, compatibility) {
        let compatability_html = "<h2>COMPATIBILITY</h2>";
        compatability_html += "<table class='ilo-tabular'><tbody><tr><th>Software type</th><th>Version</th></tr><tr><td>PCE</td><td><ul>";
        for (var i in compatibility) {
            compatability_html += `<li>${compatibility[i]}</li>`;
        }
        compatability_html += "</ul></tr></tbody></table>";
        return compatability_html;
    }

    updateSupportedOperatingSystemsFormat() {
        const table = document.getElementsByClassName("wrapped ilo-tabular relative-table confluenceTable")[0];
        const tbody = table.children[1];
        const header = tbody.children[0];
        // Check if the header has 3 items for backwards compatability
        if (!header.children[2]) {
            return;
        }
        let newHTML = "";
        table.style.width = "";

        // There is an unneccasary colgroup in the HTML here
        table.removeChild(table.children[0]);

        // Delete the "qualified" header then grab the rest of it
        header.removeChild(header.children[2]);

        newHTML += header.outerHTML;

        // Start at 1 becuase 0 is the header
        let index = 1;
        while (tbody.children[index]) {
            do {
                const tr = tbody.children[index];
                if (tr.children.length == 3) {
                    // Add the OS
                    newHTML += `<tr><td>${tr.children[0].innerText}</td><td><ul>`;
                }
                // Add the version
                
                newHTML += `<li class='support-status status-qualified'>${tr.children[tr.children.length-2].innerText}</li>`;
                index += 1;
            } while (tbody.children[index] && tbody.children[index].children.length != 3);
            newHTML += "</ul></td></tr>";
        }
        tbody.innerHTML = newHTML;
    }

    updateHeading = function(record) {
        const headings = document.getElementsByTagName('h2');
        for (let i=0;i<headings.length;i++) {
            headings[i].textContent += ` for Illumio NEN ${record.software_version}`;
            console.debug(headings[i].textContent);
        }
    }

}
